.badge-wrapper {
    position: relative;
    display: inline-block;
  }
  
  .badge-content {
    position: absolute;
    top: -12px;
    right: -8px;
    background-color: var(--primary-color);
    color: white;
    border-radius: 50%;
    padding: 4px;
    min-width: 18px;
    text-align: center;
    z-index: 1;
  }
  